/**
 * @generated SignedSource<<bc29f75584b847ae105777c63756e483>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiDesignGenEditor_CreateOrUpdateMutation$variables = {
  customPrompt?: string | null;
  presetID?: number | null;
  useAIDesignCreatorMode: boolean;
};
export type aiDesignGenEditor_CreateOrUpdateMutation$data = {
  readonly createOrUpdateDesignWithAISetting: {
    readonly customPrompt: string | null;
    readonly id: string;
    readonly presetID: number | null;
    readonly settingsID: number;
    readonly useAIDesignCreatorMode: boolean;
  };
};
export type aiDesignGenEditor_CreateOrUpdateMutation = {
  response: aiDesignGenEditor_CreateOrUpdateMutation$data;
  variables: aiDesignGenEditor_CreateOrUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customPrompt"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "presetID"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useAIDesignCreatorMode"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "customPrompt",
        "variableName": "customPrompt"
      },
      {
        "kind": "Variable",
        "name": "presetID",
        "variableName": "presetID"
      },
      {
        "kind": "Variable",
        "name": "useAIDesignCreatorMode",
        "variableName": "useAIDesignCreatorMode"
      }
    ],
    "concreteType": "DesignWithAISettingDTO",
    "kind": "LinkedField",
    "name": "createOrUpdateDesignWithAISetting",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "settingsID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "presetID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customPrompt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "useAIDesignCreatorMode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiDesignGenEditor_CreateOrUpdateMutation",
    "selections": (v3/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "aiDesignGenEditor_CreateOrUpdateMutation",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "1a12d895855e0e77eb4edf7d5dbfe52b",
    "id": null,
    "metadata": {},
    "name": "aiDesignGenEditor_CreateOrUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation aiDesignGenEditor_CreateOrUpdateMutation(\n  $presetID: Int\n  $customPrompt: String\n  $useAIDesignCreatorMode: Boolean!\n) {\n  createOrUpdateDesignWithAISetting(presetID: $presetID, customPrompt: $customPrompt, useAIDesignCreatorMode: $useAIDesignCreatorMode) {\n    id\n    settingsID\n    presetID\n    customPrompt\n    useAIDesignCreatorMode\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce6ffb1d61dbec70d4b9a2ac17747a4b";

export default node;
